import { CommonFileInfo } from "@/types/common";
import CommonImg from "@/components/Common/Img";
import DeleteIcon from "@/assets/images/delete-pink.svg";
import { Button } from "@/components/ui/button";
import { Upload } from "lucide-react";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import {
  useDeleteProjectGroupsFiles,
  useDownloadProjectGroupsFiles,
  useUploadProjectGroupsFiles,
} from "@/libs/react-query/hooks/useProjectQuery";

export default function ProjectDetailFileManagement({
  files = [],
}: {
  files: CommonFileInfo[];
}) {
  const { group_id = "" } = useParams();

  const fileInputRef = useRef<HTMLInputElement>(null);

  const { mutateAsync: uploadFile } = useUploadProjectGroupsFiles(group_id);
  const { mutateAsync: downloadFile } = useDownloadProjectGroupsFiles(group_id);
  const { mutateAsync: deleteFile } = useDeleteProjectGroupsFiles(group_id);

  const handleFileUploadChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("files", file);

    await uploadFile(formData);

    e.target.value = "";
  };

  const handleFileDownload = async (file_id: string) => {
    const { files } = await downloadFile({ files: [{ file_id }] });
    const { download_url, file_name } = files[0];

    const a = document.createElement("a");
    a.href = download_url;
    a.download = file_name;
    a.click();
  };

  const handleFileDelete = async (file_id: string) => {
    await deleteFile({ files: [{ file_id }] });
  };

  return (
    <div className="h-60 flex flex-col">
      <div className="flex flex-col gap-2 overflow-y-auto">
        {files.length === 0 ? (
          <div className="py-4 text-center text-gray-B text-lg font-bold">
            파일이 없습니다.
          </div>
        ) : (
          files.map((file: CommonFileInfo) => {
            return (
              <div
                key={file.file_id}
                className="flex items-center justify-between"
              >
                <span
                  className="text-gray-A text-sm font-semibold underline cursor-pointer"
                  onClick={() => handleFileDownload(file.file_id)}
                >
                  {file.file_name}
                </span>
                <button onClick={() => handleFileDelete(file.file_id)}>
                  <CommonImg src={DeleteIcon} alt="delete" />
                </button>
              </div>
            );
          })
        )}
      </div>
      <div className="py-2">
        <Button
          size="md"
          onClick={() => fileInputRef.current?.click()}
          className="mx-auto flex items-center gap-1 bg-dark-brown text-white hover:bg-dark-brown/90"
        >
          <span className="text-xs font-bold">파일 업로드</span>
          <Upload className="size-[18px] text-white font-bold" />
        </Button>
        <input
          ref={fileInputRef}
          type="file"
          className="hidden"
          onChange={handleFileUploadChange}
        />
      </div>
    </div>
  );
}
